module.exports = __webpack_public_path__ + "img/logo_theme.e0cd437a.png";